module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "video-modal__button",
    on: {
      "click": function($event) {
        _vm.modalActive = true
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modalActive) ? _c('div', {
    staticClass: "video-modal__modal"
  }, [_c('button', {
    staticClass: "video-modal__close",
    on: {
      "click": function($event) {
        _vm.modalActive = false
      }
    }
  }, [_c('svg', {
    staticClass: "video-modal__close-image",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 72.967 66.236"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "36.483",
      "cy": "33.118",
      "r": "25",
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "36.483",
      "cy": "33.118",
      "r": "25",
      "fill": "none",
      "stroke": "#fff",
      "stroke-miterlimit": "10",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "29.783",
      "y1": "26.418",
      "x2": "44.283",
      "y2": "40.918",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "stroke-width": "2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "29.783",
      "y1": "40.918",
      "x2": "44.283",
      "y2": "26.418",
      "fill": "none",
      "stroke": "#fff",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      "stroke-width": "2"
    }
  })])]), _vm._v(" "), _c('youtube', {
    staticClass: "video-modal__video",
    attrs: {
      "video-id": _vm.video_id,
      "player-vars": {
        autoplay: 1,
        modestbranding: 1,
        showinfo: 0,
        playsinline: 1,
        rel: 0
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32162974","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoModal.vue
// module id = 259
// module chunks = 1